import { OutlineButton } from './OutlineButton';
export default OutlineButton;
